import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.5 6.75H3.75C3.19772 6.75 2.75 7.19772 2.75 7.75V17.25C2.75 17.8023 3.19772 18.25 3.75 18.25H7.5M7.5 6.75V18.25M7.5 6.75V2.75C7.5 2.19771 7.94772 1.75 8.5 1.75H11.5C12.0523 1.75 12.5 2.19772 12.5 2.75V10.75M12.5 10.75V18.25M12.5 10.75H16.25C16.8023 10.75 17.25 11.1977 17.25 11.75V17.25C17.25 17.8023 16.8023 18.25 16.25 18.25H12.5M12.5 18.25H7.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgChart);
export { ForwardRef as ReactComponent };
